import { apiLabs } from '../../api'

const RecoverValue = async (body) => {
	
	const res = await apiLabs.post('recover_sale/value', body)
	return res
}

export default RecoverValue